import React, { forwardRef, useState, useEffect } from 'react';

import { Checkbox } from 'primereact/checkbox';
import { classNames } from 'primereact/utils';

export const GroupTitledCheckRadio = forwardRef((props, ref) => {
  const {
    name,
    title = '',
    value,
    defaultValue = '',
    items = [],
    onChange,
    error,
    disabled = false,
    readOnly = false,
  } = props;

  const [selectedOption, setSelectedOption] = useState(value);

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  function handleCheckboxChange(e) {
    const { value } = e.target;
    if (selectedOption === value) {
      setSelectedOption(defaultValue);
      onChange(defaultValue);
    } else {
      setSelectedOption(value);
      onChange(value);
    }
  }

  return (
    <>
      <div className={classNames('p-inputgroup h-full', { 'p-error': error })}>
        <span
          className="p-inputgroup-addon w-full font-medium text-center min-w-3 max-w-5"
          style={{ display: 'table' }}
        >
          <span
            style={{
              display: 'table-cell',
              verticalAlign: 'middle',
              wordBreak: 'keep-all',
            }}
          >
            {title}
          </span>
        </span>
        <div
          className={classNames(
            'p-inputgroup-addon bg-transparent w-full flex flex-auto flex-wrap align-items-center justify-content-start gap-3',
            { 'bg-gray-100': disabled }
          )}
        >
          {items.map((item, idx) => (
            <div key={`${name}_${idx}`}>
              <div className="flex flex-auto align-items-center justify-content-start gap-1">
                <Checkbox
                  inputRef={ref}
                  inputId={`trb_${props.id || name}_${idx}`}
                  name={name}
                  value={item.value}
                  onChange={(e) => handleCheckboxChange(e)}
                  checked={value === item.value}
                  disabled={disabled}
                  readOnly={readOnly}
                />
                <label htmlFor={`trb_${props.id || name}_${idx}`}>
                  {item.label}
                </label>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
});
